module.exports = __webpack_public_path__ + "static/hoivakotilive_slide_7-1df0cfabaf446032d73155c4f029316b.jpg";